<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import QuestionnareButtonColor from "../parts/QuestionnareButtonColor.vue";
import QuestionnaireOutline from "../parts/QuestionnaireOutline.vue";

type Props = {
  appointmentCompletedButtonText: string;
  appointmentNotCompletedButtonText: string;
};

defineProps<Props>();

type Emits = {
  (event: "onSubmit", message: string): void;
};
const emits = defineEmits<Emits>();
</script>

<template>
  <div class="mt-[45px]">
    <div class="w-full mb-[45px] px-8">
      <h3
        class="text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold pb-2"
      >
        Was the appointment completed?
      </h3>
      <div class="w-full flex flex-col items-start gap-3">
        <div class="w-full">
          <QuestionnareButtonColor
            @click="$emit('onSubmit', appointmentCompletedButtonText)"
            :button-text="appointmentCompletedButtonText"
          />
        </div>
        <div class="w-full">
          <QuestionnaireOutline
            @click="$emit('onSubmit', appointmentNotCompletedButtonText)"
            :button-text="appointmentNotCompletedButtonText"
          />
        </div>
      </div>
    </div>
    <div class="w-full h-[48px] pt-3 border-t border-black/15"></div>
  </div>
</template>
